const InspectMasterModel = require("@/appModel/InspectMaster/InspectMasterModel")
const UserModel = require("@/appModel/users/UserModel") 
class InspectMasterListVM {
  constructor(tenantId) {
    this.tenantId = tenantId
  }
  async init() {
    // ユーザー名表示用にユーザーリスト取得
    this.userList = await UserModel.getUserList(this.tenantId);
    // 検査リスト取得
    this.data = (await InspectMasterModel.getInspectMasterList(this.tenantId)).filter(function(item) {
      console.log(JSON.stringify(item, null, "\t"))
      return !item._deleted === true
    });
    
  }

  /**
   * フォーム設定の並び順
   * @param {*} direction true:order値増 false:order値減
   * @param {*} id 
   */
  inspectChangeOrder(pastValue, newValue, id) {
    
    this.data = this.data.map(function(item) {
      if (item.inspectMaster.order == newValue) {
        
        item.inspectMaster.order = pastValue
      } 
      return item
    })
    
    this.data = this.data.map(function(item) {
      if (item.id == id) {
        
        item.order = newValue
      }
      return item
    })
    
    this.data.inspectMaster.inspectItemList = this.data.inspectMaster.inspectItemList.sort(function(a, b){
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
      
    })
    
  }
  /**
   * 指定データを削除
   * @param {*} sk 
   */
  async removeInspectMaster(sk) {
    try {
      console.log(`removeInspectMaster ${sk}`)
      const deleteData = this.data.filter(function(item){ return item.sk == sk}.bind(this))
      if (deleteData.length > 0) {
        await InspectMasterModel.deleteInspectMaster(deleteData[0])
      } else {
        new Error({code: 1, message: `${sk} is not find.`})
      }
      
    } catch (e) {
      console.log(e)
      throw e
    }
  }
  async getInspectMaster(sk) {
    let inspectMaster = await InspectMasterModel.getInspectMaster(sk, this.tenantId)
    return inspectMaster
  }

}
module.exports = InspectMasterListVM;